var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { dequal } from 'dequal';
import { useCallback, useRef } from 'react';
import { useUpdate, useUpdatedRef } from '../../../custom-hooks';
import { useFormRoot } from '../../../providers';
import { useForm } from '../../useForm/useForm';
export const useFieldDOM = ({ autoFocus, blur, fieldId, focus, isTouched, onBlur, onFocus, setValue, updatedInitialValue, }) => {
    _react_refresh_temp_1();
    const { focusedField, isUsingStorage, methods: { setDirty }, scrolledField, } = useFormRoot();
    const { methods: { blurParent, focusParent, touchParent }, } = useForm();
    const fieldRef = useRef(null);
    /**
     * Fore some reason 'isTouched'
     * is not being set to true when `autoFocus`
     * is set on input. 'onFocusHandler' is called,
     * 'focus' is called, but 'setState' inside
     * of it is not called. So this is done here
     * explicitly.This will also handle more complex inputs
     * where we have the focusable element not
     * exactly being an input.
     */
    useUpdate(() => {
        if (autoFocus && fieldRef.current) {
            fieldRef.current.focus();
            focus();
        }
    }, [autoFocus]);
    // Focus the element from
    // root method call:
    useUpdate(() => {
        if (focusedField === fieldId && fieldRef.current) {
            fieldRef.current.focus();
        }
    }, [focusedField]);
    // Scroll the element into view
    // from root method call:
    useUpdate(() => {
        if (scrolledField === fieldId && fieldRef.current) {
            fieldRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    }, [scrolledField]);
    useUpdate(() => {
        if (isTouched) {
            touchParent();
        }
    }, [isTouched]);
    const onBlurHandler = useCallback((event) => {
        blur();
        if (typeof onBlur === 'function') {
            onBlur(event);
        }
        blurParent();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps -- WIP
    [onBlur]);
    const updatedInitialValueRef = useUpdatedRef(updatedInitialValue);
    const isUsingStorageRef = useUpdatedRef(isUsingStorage);
    const onChangeHandler = useCallback((value) => {
        // TODO: rethink this:
        if ((isUsingStorageRef.current &&
            (typeof value !== 'object' ||
                !dequal(value, updatedInitialValueRef.current))) ||
            (!isUsingStorageRef.current &&
                Array.isArray(value) &&
                typeof updatedInitialValueRef.current == 'string' &&
                updatedInitialValueRef.current.length === 0 &&
                value.length === 0
                ? true
                : !dequal(value, updatedInitialValueRef.current) || true)) {
            setDirty();
            setValue({ value });
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps -- WIP
    []);
    const onFocusHandler = useCallback((event) => {
        focus();
        if (typeof onFocus === 'function') {
            onFocus(event);
        }
        focusParent();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps -- WIP
    [onFocus]);
    return {
        fieldRef,
        onBlurHandler,
        onChangeHandler,
        onFocusHandler,
    };
};
_react_refresh_temp_1(useFieldDOM, "9xjECOOz0GpEZwiLuwI4ZbUgODM=", false, () => [useFormRoot, useForm, 
    /**
     * Fore some reason 'isTouched'
     * is not being set to true when `autoFocus`
     * is set on input. 'onFocusHandler' is called,
     * 'focus' is called, but 'setState' inside
     * of it is not called. So this is done here
     * explicitly.This will also handle more complex inputs
     * where we have the focusable element not
     * exactly being an input.
     */
    useUpdate, 
    // Focus the element from
    // root method call:
    useUpdate, 
    // Scroll the element into view
    // from root method call:
    useUpdate, useUpdate, useUpdatedRef, useUpdatedRef]);
